import React,{Component} from 'react';

import {
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  FormText,
  Button,
  Badge
} from 'reactstrap';

import Select from 'react-select';


import Form from '../Form';
import HiddenInput from '../HiddenInput';

import without from 'lodash/without';

import CloseSVG from '../../../shared/assets/close.svg';
import TrashSVG from '../../../shared/assets/trash.svg';
import InformationSVG from '../../assets/information.svg';

import { 
  formatGeofilterSelectOptions,
  buildNestedList,
  toTitleCase 
} from '../../utils';

const ClearIndicator = (props) => {
  const { getStyles, innerProps: { ref, ...restInnerProps } } = props;
  return (
    <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
      <div style={{ padding: '0px 5px' }}>
        <img src={TrashSVG} alt='Trash' />
      </div>
    </div>
  );
};

class GeofilterInput extends Component {
  constructor(){
    super();

    this.state = {
      value:[]
    };
  }

  componentDidMount(){
    const {defaultValue,geofilters} = this.props;

    if(defaultValue){
      const newValue = defaultValue
        .map((f) => geofilters.find((g) => g.code === f.code))
        .map((g) => ({
          label:g.kind === 'dma' ? toTitleCase(g.name.toLowerCase()) : `${toTitleCase(g.name.toLowerCase())} (State)`,
          value:g.code
        }));

      this.setState({value:newValue});
    }
  }

  handleChange(newValue){
    this.setState({value:newValue});
  }

  handleFormatOptionLabel(option,config){
    if(config.context === 'value' || isNaN(parseInt(option.value))){
      return (<span>{option.label}</span>)
    } else{
      return (<span>&nbsp;&nbsp;&nbsp;{option.label}</span>)
    }
  }

  render(){
    //TODO: Dont nest forms
    const {value} = this.state;

    const {geofilters,name,warning} = this.props;

    return (
      <div>
        {value
          .map((option) => geofilters.find((g) => g.code === option.value))
          .map((geofilter,index) => (
            <div key={geofilter.code}>
              <HiddenInput 
                name={`${name}[${index}][code]`} 
                value={geofilter.code}
              />
              <HiddenInput 
                name={`${name}[${index}][kind]`} 
                value={geofilter.kind}
              />
            </div>
          )
        )}
        <FormGroup>
          <Select
            isMulti
            closeMenuOnSelect={false}
            placeholder='Start typing State or DMA...'
            value={value}
            options={formatGeofilterSelectOptions(buildNestedList(geofilters))} 
            formatOptionLabel={(option,config) => this.handleFormatOptionLabel(option,config)}
            styles={{
              groupHeading:(base) => ({
                ...base,
                fontSize:'100%!important',
                textTransform:'none!important',
                color: '#999'
              }),
              clearIndicator:(base,state) => ({
                ...base,
                cursor: 'pointer'
              }),
              multiValueRemove:(base,state) => ({
                ...base,
                color:'black!important',
                backgroundColor:'#e6e6e6!important',
                cursor: 'pointer!important'
              })
            }}
            components={{ClearIndicator:ClearIndicator}}
            onChange={(value) => this.handleChange(value)}
          />
          {this.props.warning.length > 0 && (
            <FormText className='DangerFeedback'>{warning}</FormText>
          )}
        </FormGroup>
      </div>
    )
  }
}

GeofilterInput.defaultProps = {
  warning:''
};

export default GeofilterInput;


// WEBPACK FOOTER //
// ./src/shared/components/GeofilterInput/index.js